// extracted by mini-css-extract-plugin
module.exports = {"baggageCounter__plus":"baggageCounter__plus-29hxT","baggageCounter__minus":"baggageCounter__minus-382sZ"};